module.exports = __webpack_public_path__ + "prod/1.42.2/img/difficulty-one.c653463e.png";